export var defaultOptions = {
    // input color options: hex, rgb or hsl
    inputFormat: 'hex',
    // number of color stops (cannot be less than colorArray.length)
    stops: 5,
    // input color array
    colorArray: ['#fff', '#000']
};
//# sourceMappingURL=defaultOptions.js.map